import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GTMService } from '@services';
import {
  FeatureService,
  FilterType,
  Gateway,
  PowerLimitationControlCommandType,
  PowerLimitationHistoryStore,
} from '@store';
import moment, { Moment } from 'moment';
import { first, Observable } from 'rxjs';
import { DropdownSelectOption } from 'src/app/shared/components/dropdown-select/dropdown-select.component';

@Component({
  selector: 'app-power-limitation-history-filters',
  templateUrl: './power-limitation-history-filters.component.html',
  styleUrl: './power-limitation-history-filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PowerLimitationHistoryFiltersComponent implements OnInit {
  @Input() powerLimitationAmount: number;
  @Input() consumptionLimitationAmount: number;
  @Input() productionLimitationAmount: number;
  @Input() controlCommandFilterType: PowerLimitationControlCommandType;
  @Input() isLoading: boolean;
  readonly powerLimitationControlCommandType = PowerLimitationControlCommandType;

  FilterType = FilterType;
  filters: DropdownSelectOption[] = [
    {
      value: FilterType.Day,
      viewValue: this.translateService.instant('+POWER_LIMITATION_HISTORY_LOG.FILTER.DAY'),
    },
    {
      value: FilterType.Month,
      viewValue: this.translateService.instant('+POWER_LIMITATION_HISTORY_LOG.FILTER.MONTH'),
    },
    {
      value: FilterType.Year,
      viewValue: this.translateService.instant('+POWER_LIMITATION_HISTORY_LOG.FILTER.YEAR'),
    },
    {
      value: FilterType.Total,
      viewValue: this.translateService.instant('+POWER_LIMITATION_HISTORY_LOG.FILTER.TOTAL'),
    },
  ];

  defaultFilter: DropdownSelectOption;
  activeFilter: FilterType;
  gatewayProperties$: Observable<Gateway>;

  private selectedDate: Moment = moment(new Date());

  constructor(
    private featureService: FeatureService,
    private powerLimitationHistoryStore: PowerLimitationHistoryStore,
    private translateService: TranslateService,
    private gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.gatewayProperties$ = this.featureService.selectGatewayProperties();
    this.setDefaultFilter();
  }

  changeFilter(selectedFilter: { value: FilterType }): void {
    this.activeFilter = selectedFilter.value;
    this.selectedDate = moment(new Date());
    this.powerLimitationHistoryStore.setFilterDateType({
      type: this.activeFilter,
      date: this.selectedDate,
    });
    this.gtmService.track('onSet', 'Filter Type', 'powerLimitationHistory');
  }

  changeDate(date: Moment): void {
    this.selectedDate = date;
    this.powerLimitationHistoryStore.setFilterDateType({
      type: this.activeFilter,
      date: this.selectedDate,
    });
    this.gtmService.track('onChange', 'Date', 'powerLimitationHistory');
  }

  private setDefaultFilter(): void {
    this.powerLimitationHistoryStore.filterDateType$
      .pipe(first())
      .subscribe((filterType: FilterType) => {
        const foundFilter = this.filters.find((entry) => entry.value === filterType);

        this.defaultFilter = foundFilter;
        this.activeFilter = foundFilter.value;
      });
  }

  filterByPowerLimitationControlCommandType(filter: PowerLimitationControlCommandType): void {
    this.controlCommandFilterType = filter;
    this.powerLimitationHistoryStore.updateFiltersByPowerLimitationControlCommandType(filter);
  }
}
